import React from 'react';
import Icon from '../../atoms/icon/icon.js';
import Title from '../../atoms/title/title.js';
import { rightArrowIcon } from './img/right_arrow_icon.js';
import { hourglassIcon } from './img/hourglass_icon.js';
import { refreshIcon } from './img/refresh_icon.js';
import { checkmarkIcon } from './img/checkmark_icon.js';

const MethodCell = ({ type, img, text, subText }) => {
    const renderIcon = () => {
        const className = `mbw-method-cell-${type}-icon`;
        if (img && typeof img === "string") {
            return React.createElement("img", { src: img, className: className });
        }
        return (React.createElement(Icon, { className: className, dataTestId: "mbw-method-cell-icon" }, img));
    };
    const renderText = () => (React.createElement("div", { className: "mbw-method-cell-text-container" },
        React.createElement("div", { className: `mbw-method-cell-${type}-text`, "data-testid": "mbw-method-cell-text" },
            React.createElement(Title, { fontStyle: "content-default", bold: true }, text)),
        React.createElement("div", { className: "mbw-method-cell-sub-text", "data-testid": "mbw-method-cell-sub-text" },
            React.createElement(Title, { fontStyle: "content-small" }, subText))));
    const renderIconAndText = () => (React.createElement("div", { className: "mbw-method-cell-icon-and-text-container" },
        renderIcon(),
        renderText()));
    const getRightIcon = () => {
        let rightIcon = null;
        switch (type) {
            case "default":
            case "highlighted":
                rightIcon = rightArrowIcon;
                break;
            case "disabled":
                rightIcon = hourglassIcon;
                break;
            case "error":
                rightIcon = refreshIcon;
                break;
            case "success":
                rightIcon = checkmarkIcon;
                break;
            default:
                rightIcon = null;
        }
        return rightIcon;
    };
    const renderRightIcon = () => (React.createElement(Icon, { className: `mbw-method-cell-${type}-right-icon`, dataTestId: "mbw-method-cell-right-icon" }, getRightIcon()));
    const renderMethodCellContent = () => (React.createElement("div", { className: 'mbw-method-cell-content-container' },
        renderIconAndText(),
        renderRightIcon()));
    const renderMethodCell = () => (React.createElement("div", { className: `mbw-method-cell-${type}-container`, "data-testid": "mbw-method-cell-container" }, renderMethodCellContent()));
    return renderMethodCell();
};

export { MethodCell as default };
//# sourceMappingURL=method_cell.js.map
